module.exports = __webpack_public_path__ + "static/media/empty.29113f68.png";